import React, { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'

import { LntDrawer } from '@app/components/base'

import { ViewingLogs } from '@app/drawers/ViewingLogsDrawer/ViewingLogs'

import { getMonitoringTaskLogsDataFromResponse } from '@app/utils/responseAdapters'

import { getMonitoringTaskLogs } from '@app/api/routes/monitoringTasks'
import { MONITORINGS_TASKS_KEY } from '@app/constants/queryKeys'

import type { ViewingLogsDrawerProps } from './types'

export const ViewingLogsDrawer: React.FC<ViewingLogsDrawerProps> = props => {
  const { taskId } = props

  const { data: monitoringTaskLogsData } = useQuery({
    queryKey: [MONITORINGS_TASKS_KEY.taskLogs, taskId],
    queryFn: async () => await getMonitoringTaskLogs(taskId)
  })

  const monitoringsTaskLogs = useMemo(
    () => getMonitoringTaskLogsDataFromResponse(monitoringTaskLogsData),
    [monitoringTaskLogsData]
  )

  return (
    <LntDrawer
      { ...props }
      title='Просмотр логов'
    >
      <ViewingLogs logs={ monitoringsTaskLogs } />
    </LntDrawer>
  )
}
